import {
    selectDoc, event, toggleClass,
    ajax, selectArr, removeClassAll,
    hasClass, addClassAll, observeAdd, observeRemove
} from "../utils/utils";

import {initSlider} from "../helpers/service.slider";

import {formatMoney} from "../helpers/service.cart";

import {PCP} from "./component.pcp";
import {Animate} from "./component.animate";

const props = {
    pageContainer: selectDoc('#PageContainer'),

    tabs: selectArr('#ws-my-account .sidebar ul li a:not(.skip)'),
    titles: selectArr('#ws-my-account .header .title'),
    containers: selectArr('#ws-my-account .content .container'),

    //Account
    accountTab: selectDoc('#account'),
    accountTitle: selectDoc('#account-title'),
    accountContainer: selectDoc('#account-container'),
    editPassCta: selectDoc('#edit-password'),
    editPassActions: selectArr('#edit-password span'),
    editPassForm: selectDoc('#reset-password'),
    metafieldsFormStatus: selectDoc('#metafields_form #form-result'),
    metafieldsFormBtn: selectDoc('#metafields_form button'),
    metafieldsFormSuccess: selectDoc('#metafields_form #success-msg'),
    metafieldsFormError: selectDoc('#metafields_form #error-msg'),

    //Orders
    ordersTab: selectDoc('#orders'),
    ordersTitle: selectDoc('#account-title'),
    ordersContainer: selectDoc('#orders-container'),
    loadMoreCta: selectDoc('#load-more'),
    orders: selectArr('.order'),
    ctaOrder: selectArr('.cta-order'),
    ctaOrderBack: selectArr('.order-back-button'),
    details: selectArr('.details'),
    ordersTable: selectDoc('#orders-table'),

    //Returns
    returnsTab: selectDoc('#returns'),
    returnsTitle: selectDoc('#account-title'),
    returnsContainer: selectDoc('#returns-container'),

    //Shipping
    shippingTab: selectDoc('#shipping'),
    shippingContainer: selectDoc('#shipping-container'),
    addAddressCta: selectDoc('#add-new-address'),
    addAddressCtaTitles: selectArr('#add-new-address span'),
    newAddressForm: selectDoc('#address_form_new'),
    editAddressCtas: selectArr('.edit-address-cta'),
    cancelEditAddressCtas: selectArr('.cancel-edit'),

    //Initiate return
    contactSubject: selectDoc('#ContactForm #ContactForm-subject'),
    contactButton: selectDoc('#ContactForm #cta-contact'),
    returnsCta: selectArr('button.initiate-return'),
    returnsMsg: selectArr('p.initiate-return-msg')
}

const initNavBar = async () => {
    props.tabs.map(tab => {
        event(tab, 'click', function (e) {
            e.preventDefault()

            /**
             * Clean everything
             */
            removeClassAll(props.tabs, 'active')
            removeClassAll(props.titles, 'active')
            removeClassAll(props.containers, 'active')

            /**
             * Active current tab
             */
            let sections, tab = '';
            this.classList.add('active');
            switch (this.id) {
                case 'orders':
                    sections = [props.ordersTitle, props.ordersContainer]
                    tab = 'orders'
                    break;
                case 'shipping':
                    sections = [props.accountTitle, props.shippingContainer]
                    tab = 'shipping'
                    break;
                case 'returns':
                    sections = [props.returnsTitle, props.returnsContainer]
                    tab = 'returns'
                    break;
                default :
                    sections = [props.accountTitle, props.accountContainer]
                    tab = 'account'
                    break;
            }
            sections.map(section => toggleClass(section, 'active'));
            window.history.replaceState({}, 'tab', '?tab=' + tab);

        })
    })
}

const setNavTab = async () => {
    let tab = new URL(document.URL).searchParams.get("tab"),
        message = new URL(document.URL).searchParams.get("message"),
        sections, container;

    switch (tab) {
        case 'orders':
            sections = [props.ordersTab, props.ordersTitle, props.ordersContainer]
            container = props.ordersContainer;

            if(message) {
                props.returnsMsg.map(msg => {
                    msg.innerText = message
                })
            }

            break;
        case 'shipping':
            sections = [props.shippingTab, props.accountTitle, props.shippingContainer]
            container = props.shippingContainer;
            break;
        case 'returns':
            sections = [props.returnsTab, props.returnsTitle, props.returnsContainer]
            container = props.returnsContainer;
            break;
        default :
            sections = [props.accountTab, props.accountContainer, props.accountTitle]
            container = props.accountContainer;
            tab = 'account'
            break;
    }
    sections.map(section => toggleClass(section, 'active'));
    window.history.replaceState({}, 'tab', '?tab=' + tab);

    //Mobile
    if (props.pageContainer.getBoundingClientRect().width < 768) {
        setTimeout(function () {
            window.scrollTo({
                top: 0,
                left: (container.getBoundingClientRect().top - 100),
                behavior: 'smooth'
            });
        }, 700)
    }

}

const initEditPassword = async () => {
    event(props.editPassCta, 'click', function () {
        if (props.editPassForm) {
            toggleClass(props.editPassForm, 'active')
            props.editPassActions.map(action => {
                toggleClass(action, 'hide')
            })
        }
    })
}

const initEditMetafields = async () => {
    event(props.metafieldsFormBtn, 'click', function (e) {
        props.metafieldsFormBtn.style.opacity = '0.5'
    })

    observeAdd(props.metafieldsFormStatus, function (nodes) {
        nodes.map(node => {
            let button = selectDoc('#metafields_form button');
            if(node.innerText == 'OK') {
                setTimeout(function () {
                    button.style.opacity = '1'
                    button.innerText = 'Saved';
                    button.classList.add('success');
                    props.metafieldsFormError.classList.remove('show')
                    props.metafieldsFormSuccess.classList.add('show')
                    // setTimeout(function () {
                    //     location.reload();
                    // }, 3000)
                }, 1000)
            } else {
                button.style.opacity = '1'
                props.metafieldsFormError.classList.add('show')
                props.metafieldsFormSuccess.classList.remove('show')
            }
        })
    })
}

const initAddresses = async () => {
    /**
     * Add
     */
    event(props.addAddressCta, 'click', function (e) {
        e.preventDefault()
        toggleClass(props.newAddressForm, 'show')
        props.addAddressCtaTitles.map(title => {
            toggleClass(title, 'hide')
        })
    })

    /**
     * Edit
     */
    function toggleEditForm(btn, inverse = false) {
        let mainSelector = '#' + 'address_' + btn.id;
        if (inverse) {
            mainSelector = '#' + 'address_f' + btn.id;
        }

        toggleClass(selectDoc(mainSelector + ' .edit-address-cta'), 'hide')
        toggleClass(selectDoc(mainSelector + ' .edit-actions'), 'hide')

        let inputs = selectArr(mainSelector + ' .edit-address input')
        inputs.map(input => {
            input.disabled = !input.disabled
        })

        let selects = selectArr(mainSelector + ' select')
        selects.map(select => {
            select.disabled = !select.disabled
        })

        let labels = selectArr(mainSelector + ' span.address-label')
        labels.map(label => {
            toggleClass(label, 'hide')
        })

        let firstInput = selectDoc(mainSelector + ' input.first-input')
        if (firstInput) {
            firstInput.focus()
        }

        let checkbox = selectDoc(mainSelector + " input[name='address[default]']"),
            label = selectDoc(mainSelector + " .default-label");

        if (checkbox && label) {
            toggleClass(checkbox, 'show')
            toggleClass(label, 'show')
            checkbox.disabled = false;
        }
    }

    props.editAddressCtas.map(btn => {
        event(btn, 'click', function (e) {
            e.preventDefault()
            let target = selectDoc('#' + 'address_' + btn.id);
            if (target) {
                toggleEditForm(btn)
            }
        })
    })

    props.cancelEditAddressCtas.map(btn => {
        event(btn, 'click', function (e) {
            e.preventDefault()
            let target = selectDoc('#' + 'address_f' + btn.id);

            if (target) {
                toggleEditForm(btn, true)
            }
        })
    })

}

const initOrders = async () => {
    if (props.loadMoreCta) {
        event(props.loadMoreCta, 'click', function () {
            props.orders.map(order => {
                order.classList.remove('hide');
            })
            toggleClass(props.loadMoreCta, 'hide')
        })
    }

    props.ctaOrder.map(orderCta => {
        event(orderCta, 'click', function () {
            let details = selectDoc('#' + orderCta.getAttribute('data-order').replace('order', 'details'))
            if (details) {
                toggleClass(props.ordersTable, 'hide')
                toggleClass(details, 'show')

                let orderId = orderCta.getAttribute('data-order').replace('order-', '')
                removeClassAll(props.titles, 'active')

                let title = selectDoc('#order-title-' + orderId)
                if (title) {
                    if (orderCta.getAttribute('data-mobile')) {
                        if (!hasClass(title, 'active')) {
                            addClassAll(props.containers, 'hide')
                            props.ordersContainer.classList.remove('hide')
                        }
                        window.scrollTo({
                            top: 0,
                            left: 0,
                            behavior: 'smooth'
                        });
                    }
                    toggleClass(title, 'active')
                }

                //Contact Form Initiate return
                if(props.contactSubject) {
                    props.contactSubject.value = `Initiate a return requested for order #${orderId}`
                }
            }
        })
    })

    props.ctaOrderBack.map(orderCtaBack => {
        event(orderCtaBack, 'click', function () {
            toggleClass(props.ordersTable, 'hide')
            removeClassAll(props.details, 'show')
            removeClassAll(props.titles, 'active')
            toggleClass(props.accountTitle, 'active')
            removeClassAll(props.containers, 'hide')
        })
    })

    //Mobile
    initSlider('.orders-slider', {
        rewind: false,
        bound: true,
        perView: 1,
        peek: {
            before: 0,
            after: 90
        }
    })
}

const initReturns = async () => {
    props.returnsCta.map(returnBtn => {
        event(returnBtn, 'click', function () {
            props.contactSubject.value += ` item ${returnBtn.getAttribute('data-item')}`
            props.contactButton.click()
        })
    })
}

const initializer = () => {
    initNavBar()
    setNavTab()
    initEditPassword()
    initEditMetafields()
    initAddresses()
    initOrders()
    initReturns()
}

export const Account = {
    init: () => initializer()
}
